var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.step.questions),function(question){return _c('div',{key:question.id,staticClass:"mb-1"},[_c('div',[_c('b',[_vm._v(" "+_vm._s(question.text))])]),(question.answer)?_c('div',{staticClass:"whitespace-pre-wrap"},[_vm._v(_vm._s(question.answer))]):_c('div',[_c('i',[_vm._v("No comment")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }